// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1_szG","cls2":"SimplePaperPodcast-cls2_hgp SimplePaperPodcast-cls1_szG"};